import CheckboxesPresenter from "../presenter/checkboxes.js";
import SliderPresenter from "../presenter/slider.js";
import ResetPresenter from "../presenter/reset.js";

import WrapperView from "../view/wrapper.js";
import FormView from "../view/form.js";

import FilterModel from "../model/filter.js";

import {
  VISIBLE_FIELDSET_NUMBER
} from "../../const.js";

export default class FiltersWrapper {
  constructor(
      listingWrapperView,
      changeFilter,
      animation,
      scrollToElement,
      browserNavigation
  ) {
    this._listingWrapperView = listingWrapperView;
    this._element = this._listingWrapperView.getFiltersWrapperElement();
    this._changeFilter = changeFilter;
    this._animation = animation;
    this._browserNavigation = browserNavigation;

    this._checkboxesPresenters = [];
    this._slidersPresenters = [];
    this._resetPresenter = null;

    this._wrapperView = null;
    this._formView = null;
    this._resetView = null;

    this._filterModel = null;

    this._scrollToElement = scrollToElement;
    this._updateEnabledValues = this._updateEnabledValues.bind(this);
    this._handleFormChange = this._handleFormChange.bind(this);
    this._handleFormSubmit = this._handleFormSubmit.bind(this);
  }

  init() {
    this._wrapperView = new WrapperView(this._element);
    this._formView = new FormView(this._wrapperView.getElement());

    this._initModel();

    this._resetPresenter = new ResetPresenter(
        this._wrapperView,
        this._changeFilter,
        this._animation,
        this._scrollToElement,
        this._listingWrapperView
    );
    this._resetPresenter.init();

    const slidersElements = this._formView.getSlidersFieldsets();
    const checkboxesElement = this._formView.getCheckboxesFieldsets();

    Array.from(checkboxesElement).forEach((item, index) => {
      const isActive = (index > VISIBLE_FIELDSET_NUMBER - 1) ? false : true;

      const checkboxesPresenter = new CheckboxesPresenter(
          item,
          this._scrollToElement,
          this._animation,
          this._resetPresenter,
          this._browserNavigation,
          isActive
      );
      checkboxesPresenter.init();

      this._checkboxesPresenters.push(checkboxesPresenter);
    });

    Array.from(slidersElements).forEach((item) => {
      const sliderPresenter = new SliderPresenter(
          item,
          this._changeFilter,
          this._formView.getElement(),
          this._resetPresenter,
          this._browserNavigation
      );
      sliderPresenter.init();

      this._slidersPresenters.push(sliderPresenter);
    });

    this._changeFilter.setFilterFormElement(this._formView.getElement());
    this._changeFilter.setInputElements(this._formView.getInputsElements());
    this._changeFilter.addLoadObserver(this._updateEnabledValues);
    this._formView.setChangeHandler(this._handleFormChange);
    this._formView.setSubmitHandler(this._handleFormSubmit);

    this._resetPresenter.checkReset();
  }

  getFormElement() {
    return this._wrapperView.getElement();
  }

  getResetButtonWrapper() {
    return this._wrapperView.getResetButtonWrapper();
  }

  getResetButtonText() {
    return this._wrapperView.getResetButtonText();
  }

  setResetButtonText(text) {
    this._wrapperView.setResetButtonText(text);
  }

  getListingWrapperView() {
    return this._listingWrapperView;
  }

  getSlidersElements() {
    return this._slidersPresenters.map((presenter) => {
      return presenter.getSliderElement();
    });
  }

  getInputsElements() {
    return this._slidersPresenters
      .map((presenter) => {
        return presenter.getInputsElements();
      })
      .flat();
  }

  setCheckboxesRelativeScrollContainer(container) {
    this._checkboxesPresenters.forEach((presenter) => {
      presenter.setRelativeScrollContainer(container);
    });
  }

  removeCheckboxesRelativeScrollContainer() {
    this._checkboxesPresenters.forEach((presenter) => {
      presenter.removeRelativeScrollContainer();
    });
  }

  setResetRelativeScrollElements(container, element) {
    this._resetPresenter.setRelativeScrollElements(container, element);
  }

  removeResetRelativeScrollElements() {
    this._resetPresenter.removeRelativeScrollElements();
  }

  disableValue(property, value = null) {
    this._slidersPresenters.forEach((presenter) => {
      if (property === presenter.getName()) {
        presenter.forceReset();
      }
    });

    this._checkboxesPresenters.forEach((presenter) => {
      if (
        property !== presenter.getName() ||
        !value
      ) {
        return;
      }

      presenter.disableValue(value);
    });
  }

  _initModel() {
    const elementData = this._wrapperView.getElement().dataset;
    const modelData = Object.assign(
        {},
        elementData
    );

    this._filterModel = new FilterModel(modelData);
    this._wrapperView.clearData();

    this._changeFilter.setFilterModel(this._filterModel);
  }

  _updateEnabledValues(data) {
    const enabledData = data.enabled;

    if (!enabledData) {
      this._checkboxesPresenters.forEach((presenter) => presenter.reset());
      this._slidersPresenters.forEach((presenter) => presenter.reset());
      return;
    }

    this._checkboxesPresenters.forEach((presenter) => {
      presenter.updateEnabledValues(enabledData);
    });

    this._slidersPresenters.forEach((presenter) => {
      presenter.updateEnabledValues(enabledData);
    });
  }

  _handleFormChange() {
    this._changeFilter.updateProductsData();
  }

  _handleFormSubmit(evt) {
    evt.preventDefault();
    this._changeFilter.updateProductsData();
  }
}
